import React from 'react';
import { Form, Col, Row } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

import Title from 'components/Title/Title';

import { ToggleButton, ToggleButtonsContainer } from './FormToggle.styles';

const FormItem = Form.Item;

const Toggle = ({ label, children, value, onChange }) => {
  return (
    <Row align="middle">
      <Col span={17} lg={18}>
        <Title type="toggle" marginBottom="32px">
          {label}
        </Title>
      </Col>
      <ToggleButtonsContainer span={7} lg={6}>
        <ToggleButton
          isToggled={value && value.value}
          onClick={() => {
            onChange({
              value: true
            });
          }}
        >
          <CheckOutlined />
        </ToggleButton>
        <ToggleButton
          isToggled={!value || (value && !value.value)}
          onClick={() => {
            onChange({
              value: false
            });
          }}
        >
          <CloseOutlined />
        </ToggleButton>
      </ToggleButtonsContainer>
      {value && value.value && <Col span={24}>{children}</Col>}
    </Row>
  );
};

const FormToggle = ({ name, ...props }) => {
  return (
    <FormItem name={name}>
      <Toggle {...props} />
    </FormItem>
  );
};

export default FormToggle;
